import { Button } from '@montel/montelpro-shared-components-v2';
import { createColumnHelper } from '@tanstack/react-table';
import { ButtonContainer } from 'components/common/Product/Cells/styles';
import { HeadCell, SortableHeadCell, TextCell } from 'components/tables/cells';
import { Provider } from 'domain/subscription/interfaces/Subscription';

const columnHelper = createColumnHelper<Provider>();

const getColor = (addedProviders: Provider[] | undefined, providerId: number) =>
	addedProviders?.some((p) => p.id === providerId) ? 'bgSuccess' : undefined;

export const defaultProviderBlacklistTableColumns = {
	name: (addedProviders?: Provider[]) =>
		columnHelper.accessor((row) => row.name, {
			id: 'name',
			enableSorting:
				addedProviders && addedProviders.length > 0 ? false : true,
			size: 100,
			header: ({ header }) => (
				<SortableHeadCell text="Name" header={header} />
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					color={getColor(addedProviders, info.row.original.id)}
				/>
			),
		}),
	code: (addedProviders?: Provider[]) =>
		columnHelper.accessor((row) => row.code, {
			id: 'code',
			enableSorting:
				addedProviders && addedProviders.length > 0 ? false : true,
			header: ({ header }) => (
				<SortableHeadCell text="Code" header={header} />
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					color={getColor(addedProviders, info.row.original.id)}
				/>
			),
		}),
	actions: (
		removeProvider: (provider: Provider) => void,
		disabled?: boolean,
	) =>
		columnHelper.accessor(() => null, {
			id: 'actions',
			enableSorting: false,
			meta: { width: '120px' },
			header: () => <HeadCell text="" />,
			cell: (info) => (
				<ButtonContainer>
					<Button
						size="sm"
						text={'Remove provider'}
						type="button"
						variant={'secondary'}
						isDisabled={disabled}
						onClick={(e) => {
							e.stopPropagation();
							removeProvider(info.row.original);
						}}
					/>
				</ButtonContainer>
			),
		}),
};
